import { Overline, Reveal } from "@/components/motion";

const SUPPORT_EMAIL = "destek@uzakyonetim.com.tr";

function LegalPage({ title, updated, sections, testId }) {
  return (
    <main data-testid={testId} className="pb-24 pt-36 md:pb-32 md:pt-44">
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <Reveal>
          <Overline>Yasal</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-display text-4xl font-bold tracking-tighter text-[#0A0A0A] sm:text-5xl">
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-4 text-sm font-medium uppercase tracking-[0.15em] text-[#9CA3AF]">
            Son güncelleme: {updated}
          </p>
        </Reveal>

        <div className="mt-14 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={s.heading} delay={0.05 * (i % 4)}>
              <section data-testid={`${testId}-section-${i}`}>
                <h2 className="flex items-baseline gap-3 font-display text-xl font-bold tracking-tight text-[#003366]">
                  <span className="text-sm font-semibold text-[#9CA3AF]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {s.heading}
                </h2>
                {s.body && (
                  <p className="mt-3 text-sm leading-relaxed text-[#525252] md:text-base">
                    {s.body}
                  </p>
                )}
                {s.items && (
                  <ul className="mt-3 list-disc space-y-2 pl-6 text-sm leading-relaxed text-[#525252] md:text-base">
                    {s.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}

export function PrivacyPage() {
  return (
    <LegalPage
      testId="privacy-page"
      title="Gizlilik Politikası"
      updated="Eylül 2026"
      sections={[
        {
          heading: "Toplanan Veriler",
          body: "Hizmetimizi kullanırken ad, e-posta adresi, cihaz bilgileri ve IP adresi gibi veriler toplanır.",
        },
        {
          heading: "Kullanım Amacı",
          body: "Toplanan veriler; hizmet sunumu, faturalama ve sizinle iletişim kurulması amaçlarıyla kullanılır.",
        },
        {
          heading: "Veri Saklama",
          body: "Verileriniz güvenli sunucularda saklanır ve SSL ile şifrelenerek korunur.",
        },
        {
          heading: "Üçüncü Taraflar",
          body: "Verileriniz yalnızca hizmetin sunulması için gerekli olan üçüncü taraflarla paylaşılır: ödeme işlemleri için Shopier, e-posta gönderimi için Resend. Bu taraflar verilerinizi yalnızca hizmet kapsamında işler.",
        },
        {
          heading: "Kullanıcı Hakları",
          body: `Verilerinize erişim, düzeltme ve silme haklarına sahipsiniz. Talepleriniz için ${SUPPORT_EMAIL} adresine yazabilirsiniz.`,
        },
        {
          heading: "Çerezler",
          body: "Sitemizde yalnızca oturum yönetimi için zorunlu çerezler kullanılır. Reklam veya izleme çerezi kullanılmaz.",
        },
        {
          heading: "İletişim",
          body: `Gizlilik ile ilgili tüm sorularınız için: ${SUPPORT_EMAIL}`,
        },
      ]}
    />
  );
}

export function TermsPage() {
  return (
    <LegalPage
      testId="terms-page"
      title="Kullanım Koşulları"
      updated="Eylül 2026"
      sections={[
        {
          heading: "Hizmetin Tanımı",
          body: "UzakYönetim RMM; sunucularınızı, bilgisayarlarınızı ve ağ cihazlarınızı uzaktan izlemenizi, yönetmenizi ve desteklemenizi sağlayan bir uzaktan yönetim platformudur.",
        },
        {
          heading: "Abonelik ve Ödeme",
          body: "Hizmet aylık veya yıllık abonelik ile sunulur. Ödemeler Shopier altyapısı üzerinden güvenle alınır.",
        },
        {
          heading: "Deneme Süresi",
          body: "Tüm planlar 14 gün ücretsiz denenebilir. Deneme süresi boyunca kredi kartı bilgisi gerekmez.",
        },
        {
          heading: "İptal ve İade",
          body: "Aylık planda istediğiniz zaman iptal edebilirsiniz. Yıllık planda iade yapılmaz; kalan süreniz devam eder.",
        },
        {
          heading: "Cihaz Limiti",
          body: "Planınızın cihaz limiti aşıldığında yeni cihaz eklenmesi engellenir; mevcut cihazlarınız çalışmaya kesintisiz devam eder.",
        },
        {
          heading: "Kullanıcı Yükümlülükleri",
          body: "Hizmeti yürürlükteki yasalara uygun şekilde kullanmak ve hesap güvenliğinizi korumak sizin sorumluluğunuzdadır.",
        },
        {
          heading: "Hizmet Sürekliliği",
          body: "Planlı bakım çalışmaları önceden kullanıcılara bildirilir. Kesinti süreleri asgari düzeyde tutulur.",
        },
        {
          heading: "Fikri Mülkiyet",
          body: "Platform, marka ve tüm içerikler UzakYönetim'e aittir. İzinsiz kopyalanamaz veya çoğaltılamaz.",
        },
        {
          heading: "Değişiklik Hakkı",
          body: "Bu koşullar zaman zaman güncellenebilir. Önemli değişikliklerde kullanıcılar önceden bilgilendirilir.",
        },
        {
          heading: "İletişim",
          body: `Kullanım koşulları ile ilgili tüm sorularınız için: ${SUPPORT_EMAIL}`,
        },
      ]}
    />
  );
}

export function KvkkPage() {
  return (
    <LegalPage
      testId="kvkk-page"
      title="KVKK Kapsamında Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni"
      updated="Eylül 2026"
      sections={[
        {
          heading: "Veri Sorumlusu",
          body: "6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında veri sorumlusu UzakYönetim'dir (uzakyonetim.com.tr).",
        },
        {
          heading: "İşlenen Kişisel Veriler",
          items: ["Ad soyad", "E-posta adresi", "IP adresi", "Cihaz bilgileri"],
        },
        {
          heading: "İşlenme Amaçları",
          body: "Kişisel verileriniz; hizmet sunumu, faturalama, iletişim ve güvenlik amaçlarıyla işlenir.",
        },
        {
          heading: "Aktarılan Taraflar",
          body: "Verileriniz yalnızca hizmetin gerektirdiği ölçüde; ödeme işlemleri için Shopier'e, e-posta gönderimi için Resend'e aktarılır.",
        },
        {
          heading: "Hukuki Sebep",
          body: "Verileriniz açık rızanız ve sözleşmenin ifası hukuki sebeplerine dayanılarak işlenir.",
        },
        {
          heading: "Haklarınız (KVKK Madde 11)",
          body: "Kişisel verileriniz hakkında bilgi alma, düzeltilmesini isteme, silinmesini talep etme ve işlenmeye itiraz etme haklarına sahipsiniz.",
        },
        {
          heading: "Başvuru",
          body: `KVKK kapsamındaki tüm taleplerinizi ${SUPPORT_EMAIL} adresine iletebilirsiniz. Başvurunuz en kısa sürede yanıtlanır.`,
        },
      ]}
    />
  );
}
